export default "__VITE_ASSET__78595a02__"